export { default } from './MapVisModal';
